import React from "react";
// nodejs library that concatenates classes
// reactstrap components
import {
    Button,
    Card,
    CardBody,
    Col,
    Container,
    FormGroup,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Row,
    Spinner
} from "reactstrap";

// core components
import MainNavbar from "components/Navbars/MainNavbar.js";

// index page sections
import CardsFooter from "../components/Footers/CardsFooter";
import classnames from "classnames";

const axios = require('axios');

const typeMap = {
    "Award": {
        "icon": "ni ni-trophy",
        "scheme": "success"
    },
    "Event": {
        "icon": "ni ni-calendar-grid-58",
        "scheme": "default"
    },
    "Scholarship": {
        "icon": "ni ni-paper-diploma",
        "scheme": "primary"
    },
    "Bursary": {
        "icon": "ni ni-money-coins",
        "scheme": "warning"
    }
}

function getTheme(op) {
    return typeMap[op["Category"]] || {
        "icon": "ni ni-hat-3",
        "scheme": "danger"
    }
}

class OpportunitiesPage extends React.Component {
    state = {"filters": {"Category": "default", "Company": "default", "Role Industry": "default"}};

    componentDidMount() {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        this.refs.main.scrollTop = 0;

        axios.get("https://script.google.com/macros/s/AKfycbycHW3TFa3OKMxFTlu8wzLm0-_w2qTmQuEN8QcIZP6c4awGiuaA4-qg0FX5PDsT1E3M/exec").then(res => {
            this.setState({
                "opportunities": res.data.sort((a, b) => a["Category"].localeCompare(b["Category"])),
                "filteredOpportunities": res.data.sort((a, b) => a["Category"].localeCompare(b["Category"]))
            })
        })
    }

    filterOpportunities(field, value) {
        const oldFilters = this.state.filters;
        oldFilters[field] = value
        this.setState({"filters": oldFilters})
        let filteredOps = this.state.opportunities
        Object.keys(oldFilters).forEach((k) => {
            let v = oldFilters[k]
            if (v !== "default") {
                filteredOps = filteredOps.filter(x => x[k] === v)
            }
        })
        this.setState({"filteredOpportunities": filteredOps})
    }


    render() {
        return (
            <>
                <MainNavbar/>
                <main ref="main">
                    <div className="position-relative">
                        {/* shape Hero */}
                        <section className="section section-lg section-shaped pb-50">
                            <div className="shape shape-style-1 shape-default">
                            </div>
                            <Container className="py-lg-md d-flex">
                                <div className="col px-0">
                                    <Row>
                                        <Col lg="8">
                                            <h1 className="display-3 text-white">
                                                Latest Opportunities
                                            </h1>
                                            <p className="lead text-white" style={{fontSize: "24px"}}>
                                                A collated list of up to date opportunities including Events, Awards and
                                                Scholarships
                                            </p>
                                        </Col>
                                        <Col lg="4">
                                            {/*<img src={}/>*/}
                                        </Col>
                                    </Row>
                                </div>
                            </Container>
                            <div className="separator separator-bottom separator-skew">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    preserveAspectRatio="none"
                                    version="1.1"
                                    viewBox="0 0 2560 100"
                                    x="0"
                                    y="0"
                                >
                                    <polygon
                                        className="fill-white"
                                        points="2560 0 2560 100 0 100"
                                    />
                                </svg>
                            </div>
                        </section>
                        {/* 1st Hero Variation */
                        }
                    </div>

                    <section id="upcoming" className="section section-lg">
                        <Container>
                            <Row className="justify-content-center text-center">
                                <Col lg="8">
                                    <h2 className="display-3">Opportunities</h2>
                                    <p className="lead text-muted text-center">
                                        Collated by Simran and Vamika
                                    </p>
                                </Col>
                            </Row>
                            {this.state.opportunities && <Row>
                                <Col sm={12} md={4}>
                                    <FormGroup>
                                        <small>Category</small><br/>
                                        <Input type="select" value={this.state.filters["Category"]}
                                               onChange={(e) => this.filterOpportunities("Category", e.target.value)}>
                                            <option value={"default"}>All Categories</option>
                                            {[...new Set(this.state.opportunities.map(opportunity => opportunity.Category)).values()].map(category => {
                                                return <option>{category}</option>
                                            })}
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col sm={12} md={4}>
                                    <FormGroup>
                                        <small>Company</small><br/>
                                        <Input type="select" value={this.state.filters["Company"]}
                                               onChange={(e) => this.filterOpportunities("Company", e.target.value)}>
                                            <option value={"default"}>All Companies</option>
                                            {[...new Set(this.state.opportunities.map(opportunity => opportunity.Company)).values()].map(category => {
                                                return <option>{category}</option>
                                            })}
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col sm={12} md={4}>
                                    <FormGroup>
                                        <small>Industry</small><br/>
                                        <Input type="select" value={this.state.filters["Role Industry"]}
                                               onChange={(e) => this.filterOpportunities("Role Industry", e.target.value)}>
                                            <option value={"default"}>All Industries</option>
                                            {[...new Set(this.state.opportunities.map(opportunity => opportunity["Role Industry"])).values()].map(category => {
                                                return <option>{category}</option>
                                            })}
                                        </Input>
                                    </FormGroup>
                                </Col>
                            </Row>}
                            <Row>
                                {this.state.filteredOpportunities ? this.state.filteredOpportunities.map(opportunity => {
                                    return <Col md={"4"} style={{marginTop: "30px"}}><a href={opportunity["Link"]}
                                                                                        rel="noopener noreferrer"
                                                                                        target={"_blank"}>
                                        <Card className="card-lift--hover shadow border-0" style={{height: "100%"}}>
                                            <CardBody className="py-5">
                                                <div
                                                    className={`icon icon-shape icon-shape-${getTheme(opportunity).scheme} rounded-circle mb-4`}>
                                                    <i className={getTheme(opportunity).icon}/>
                                                </div>
                                                <h6 className={`text-${getTheme(opportunity).scheme}`}>
                                                    {opportunity["Program Title"]}<br/>
                                                    <small
                                                        className="text-muted">{opportunity["Company"]} - {opportunity["Category"]}</small>
                                                </h6>
                                                <p className="description mt-3">
                                                    <b>Eligible Years: </b>{opportunity["Years For"]}<br/>
                                                    <b>Diversity Criteria: </b>{opportunity["Diversity Criteria"]}<br/>
                                                    <b>Industry: </b>{opportunity["Role Industry"]}<br/>
                                                    {opportunity["Deadline Date"] ? <>
                                                        <b>Deadline: </b>{opportunity["Deadline Date"]}<br/></> : <></>}
                                                </p>
                                                <Button
                                                    className="mt-4"
                                                    color={getTheme(opportunity).scheme}
                                                    href={opportunity["Link"]}
                                                    target={"_blank"}
                                                >
                                                    Learn more
                                                </Button>
                                            </CardBody>
                                        </Card></a>
                                    </Col>
                                }) : <p className={"text-center"} style={{margin: "0 auto", marginTop: "20px"}}><Spinner
                                    color="primary"/><br/>Loading Opportunities...</p>}
                            </Row>
                        </Container>
                    </section>

                    <section id="contact" className="bg-primary" style={{paddingBottom: "100px"}}>
                        <Container className="pt-lg">
                            <Row className="text-center justify-content-center">
                                <Col lg="10">
                                    <h2 className="display-3 text-white">Contact Us</h2>
                                    <p className="lead text-white">
                                        Use the contact form below to get in touch with us!
                                    </p>
                                </Col>
                            </Row>
                            <Row className="justify-content-center">
                                <Col lg="8">
                                    <Card className="bg-gradient-secondary shadow">
                                        <CardBody className="p-lg-5">
                                            <h4 className="mb-1">Just fill out the form below!</h4>
                                            <form id="contactform"
                                                  action="https://formsubmit.io/send/ff1fab0a-a2bd-419b-b8ac-489d4d39c468"
                                                  method="POST">
                                                <input name="_formsubmit_id" type="text" style={{display: "none"}}/>
                                                <input name="_redirect" type="hidden" id="name"
                                                       value="http://wic.doc.ic.ac.uk"/>
                                                <FormGroup
                                                    className={classnames("mt-5", {
                                                        focused: this.state.nameFocused
                                                    })}
                                                >
                                                    <InputGroup className="input-group-alternative">
                                                        <InputGroupAddon addonType="prepend">
                                                            <InputGroupText>
                                                                <i className="ni ni-circle-08"/>
                                                            </InputGroupText>
                                                        </InputGroupAddon>
                                                        <Input
                                                            placeholder="Your name"
                                                            type="text"
                                                            name="name"
                                                            onFocus={e => this.setState({nameFocused: true})}
                                                            onBlur={e => this.setState({nameFocused: false})}
                                                        />
                                                    </InputGroup>
                                                </FormGroup>
                                                <FormGroup
                                                    className={classnames({
                                                        focused: this.state.emailFocused
                                                    })}
                                                >
                                                    <InputGroup className="input-group-alternative">
                                                        <InputGroupAddon addonType="prepend">
                                                            <InputGroupText>
                                                                <i className="ni ni-email-83"/>
                                                            </InputGroupText>
                                                        </InputGroupAddon>
                                                        <Input
                                                            placeholder="Email address"
                                                            type="email"
                                                            name="email"
                                                            onFocus={e => this.setState({emailFocused: true})}
                                                            onBlur={e => this.setState({emailFocused: false})}
                                                        />
                                                    </InputGroup>
                                                </FormGroup>
                                                <FormGroup className="mb-4">
                                                    <Input
                                                        className="form-control-alternative"
                                                        cols="80"
                                                        name="message"
                                                        placeholder="Type a message..."
                                                        rows="4"
                                                        type="textarea"
                                                    />
                                                </FormGroup>
                                                <div>
                                                    <Button
                                                        block
                                                        className="btn-round"
                                                        color="primary"
                                                        size="lg"
                                                        type="submit"
                                                    >
                                                        Send Message
                                                    </Button>
                                                </div>
                                            </form>

                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </Container>

                    </section>
                </main>
                <CardsFooter/>
            </>
        )
            ;
    }
}

export default OpportunitiesPage;
